import DataType from 'scoreboard/datasets/model/data-type'
const { POSTAL_CODE, COUNTY, STATE_PROVINCE } = DataType

const typeConversion = {
	postal: POSTAL_CODE,
	subdivision: COUNTY,
	region: STATE_PROVINCE
}

const dataTypeConversion = {
	[POSTAL_CODE]: 'postal',
	[COUNTY]: 'subdivision',
	[STATE_PROVINCE]: 'region'
}

/**
 * Given a tree type from the geographic rollup trees, returns the corresponding
 * data type
 *
 * @param {String} treeType a tree type string from the geographic rollup trees
 * @return {String} the corresponding geographic data type
 */
function treeTypeToDataType(treeType) {
	return typeConversion[treeType] || treeType
}

/**
 * Given a geographic data type, returns the corresponding tree type for a
 * geographic rollup tree
 *
 * @param {String} dataType a geographic data type
 * @return {String} the corresponding geographic rollup tree type string
 */
function dataTypeToTreeType(dataType) {
	return dataTypeConversion[dataType] || dataType
}

export default treeTypeToDataType
export { dataTypeToTreeType }

treeTypeToDataType.__filename__ = 'components/tree-type-to-data-type.js'
